const REQUEST_SECTIONS = state => {
  state.status = "fetching";
};

const SUCCESS_REQUEST_SECTIONS = (state, { body }) => {
  state.Sections = body;
  state.status = "success";
};

const FAILURE_REQUEST_SECTIONS = state => {
  state.status = "failure";
};

const REQUEST_DELETE_SECTION = state => {
  state.statusDelete = "fetching";
};

const SUCCESS_REQUEST_DELETE_SECTION = state => {
  state.statusDelete = "success";
};

const FAILURE_REQUEST_DELETE_SECTION = state => {
  state.statusDelete = "failure";
};

const REQUEST_UPDATE_SECTION = state => {
  state.statusUpdate = "fetching";
};

const SUCCESS_REQUEST_UPDATE_SECTION = state => {
  state.statusUpdate = "success";
};

const FAILURE_REQUEST_UPDATE_SECTION = state => {
  state.statusUpdate = "failure";
};

const REQUEST_SECTION_HISTORY = state => {
  state.statusHistory = "fetching";
};

const SUCCESS_REQUEST_SECTION_HISTORY = (state, { body }) => {
  //console.log("SUCCESS_HISTORY")
  //console.log(body.history)
  state.History = body;
  state.statusHistory = "success";
};

const FAILURE_REQUEST_SECTION_HISTORY = state => {
  state.statusHistory = "failure";
};

const REQUEST_CREATE_SECTION = state => {
  state.statusCreate = "fetching";
};

const SUCCESS_REQUEST_CREATE_SECTION = (state, { body }) => {
  state.CreatedSection = body
  state.statusCreate = "success";
};

const FAILURE_REQUEST_CREATE_SECTION = state => {
  
  state.statusCreate = "failure";
};

const REQUEST_DEACTIVATE_SECTION = state => {
  state.statusDeactivate = "fetching";
};

const SUCCESS_REQUEST_DEACTIVATE_SECTION = state => {
  state.statusDeactivate = "success";
};

const FAILURE_REQUEST_DEACTIVATE_SECTION = state => {
  state.statusDeactivate = "failure";
};
export default {
  REQUEST_SECTIONS,
  SUCCESS_REQUEST_SECTIONS,
  FAILURE_REQUEST_SECTIONS,
  REQUEST_CREATE_SECTION,
  SUCCESS_REQUEST_CREATE_SECTION,
  FAILURE_REQUEST_CREATE_SECTION,
  REQUEST_SECTION_HISTORY,
  SUCCESS_REQUEST_SECTION_HISTORY,
  FAILURE_REQUEST_SECTION_HISTORY,
  REQUEST_DELETE_SECTION,
  SUCCESS_REQUEST_DELETE_SECTION,
  FAILURE_REQUEST_DELETE_SECTION,
  REQUEST_UPDATE_SECTION,
  SUCCESS_REQUEST_UPDATE_SECTION,
  FAILURE_REQUEST_UPDATE_SECTION,
  REQUEST_DEACTIVATE_SECTION,
  SUCCESS_REQUEST_DEACTIVATE_SECTION,
  FAILURE_REQUEST_DEACTIVATE_SECTION
};
